import styled from 'styled-components';
import device from '../../mediaQueries';

const ChangeShippingCountryWrapper = styled.div`
  display: flex;
  z-index: 999;
  background: white;
  ${device.desktop`
    position: absolute;
    top: 45px;
    width: 268px;
		max-height: 225px;
    border: solid 1px black;
    border-radius: 5px;
    transform: translateX(-40%);
	`}
  ${device.mobile`
    min-height: 99%;
    position: fixed;
    top: 80px;
    width: 100%;
		height: 100%;
	`}
`;

export default ChangeShippingCountryWrapper;
